var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowBgOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5049,
    cy: 10.5283,
    r: 10.5283,
    fill: "#FFEDD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.88265C12.5 5.46844 12.1642 5.13265 11.75 5.13265C11.3358 5.13265 11 5.46844 11 5.88265L12.5 5.88265ZM11 5.88265L11 14.5205L12.5 14.5205L12.5 5.88265L11 5.88265Z",
    fill: "#FF7900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6816 10.8156L11.799 14.6982",
    stroke: "#FF7900",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7011 14.698L7.81842 10.8153",
    stroke: "#FF7900",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowBgOrange);
export default __webpack_public_path__ + "static/media/downArrow-bg-orange.6ea111ebff8eb65d8c39f4212e6f3fa2.svg";
export { ForwardRef as ReactComponent };